/**
 * Routes that should render immediately without waiting for Clerk to load.
 * Matches public marketing + embed routes from middleware.
 */
import { INBOUND_GPT_SUBROUTES } from "~/lib/inbound-gpt/paths";
import { MARKETING_SOLUTION_SLUGS } from "~/lib/inbound-gpt/solution-slugs";
import { isClerkAuthPath } from "~/lib/auth-paths";

export function isClerkOptionalPath(pathname: string): boolean {
  if (isClerkAuthPath(pathname)) {
    return true;
  }

  if (
    pathname === "/" ||
    pathname === "/about" ||
    pathname.startsWith("/about/") ||
    pathname === "/features" ||
    pathname === "/pricing" ||
    pathname.startsWith("/pricing/") ||
    pathname === "/product" ||
    pathname.startsWith("/product/") ||
    pathname.startsWith("/agents") ||
    pathname.startsWith("/employers") ||
    pathname === "/partners" ||
    pathname.startsWith("/w/") ||
    pathname.startsWith("/watch/") ||
    pathname.startsWith("/chat/") ||
    pathname.startsWith("/agent/") ||
    pathname.startsWith("/onboarding/") ||
    pathname === "/onboard" ||
    pathname.startsWith("/onboard/") ||
    // URL submit lands here. Don't block first paint on Clerk — Google
    // sign-in continues on app.easygpt.builders, then returns to this page.
    pathname === "/start" ||
    pathname.startsWith("/start/") ||
    pathname === "/book" ||
    pathname.startsWith("/book/") ||
    pathname === "/agent-ready" ||
    pathname.startsWith("/agent-ready/") ||
    // agentready.siteglue.ai rewrites this public URL. usePathname() does not see /agent-ready.
    pathname.startsWith("/report/") ||
    pathname === "/get-started" ||
    pathname.startsWith("/get-started/") ||
    pathname === "/widget-dev-test" ||
    pathname === "/widget-test" ||
    pathname.startsWith("/widget-preview/")
  ) {
    return true;
  }

  for (const slug of INBOUND_GPT_SUBROUTES) {
    if (pathname === `/${slug}` || pathname.startsWith(`/${slug}/`)) {
      return true;
    }
  }

  for (const slug of MARKETING_SOLUTION_SLUGS) {
    if (pathname === `/${slug}`) {
      return true;
    }
  }

  return false;
}
